export interface AppLanguage {
  code: string;
  key?: string;
  name?: string;
  codeUI: string;
}
